import { Button } from '@wheely/ui-kit';
import { FormattedMessage } from 'react-intl';

import s from './styles.module.css';

const ReportSentDialog = ({ email, onClose }: { email: string; onClose: () => void }) => (
  <>
    <div className={s.body}>
      <FormattedMessage
        defaultMessage="Report sent to {email}"
        id="ErN4/n"
        description="Dialog title"
        values={{ email }}
      />
    </div>
    <div className={s.footer}>
      <Button onClick={onClose}>
        <FormattedMessage defaultMessage="Done" id="xFr/Ny" description="Dialog confirm button" />
      </Button>
    </div>
  </>
);

export { ReportSentDialog };
